<script>
import { mapActions } from 'vuex';
import request from '@/services/request'
import Catalogos from '@/services/catalogue';
import Multiselect from 'vue-multiselect'

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    components: {
        Multiselect,
        DatePicker
    },
    data() {
        return {
            catalogue: new Catalogos(),
            errors: {},
            companies: [],
            users: [],

            form: {
                id: '',
                name: '',
                total: '',
                program_type_id: 1,
                contributions_count: '',
                company_ids: [],
                users: [],
                program_installments: [],
                buildings: []
            }
        }
    },

    watch: {
        'form.contributions_count': {
            handler(val) {
                const n = Number(val);

                if (!n || n < 1) {
                    this.form.program_installments = [];
                    return;
                }

                const prevList = Array.isArray(this.form.program_installments)
                    ? this.form.program_installments
                    : [];

                const prev = new Map(
                    prevList.map(item => [Number(item.number), item]) // 👈 normaliza
                );

                const next = [];
                for (let i = 1; i <= n; i++) {
                    const existing = prev.get(i);

                    if (existing) {
                        existing.number = i; // asegura consistencia
                        next.push(existing);
                    } else {
                        next.push({
                            number: i,
                            amount: 0,
                            due_date: null
                        });
                    }
                }

                this.form.program_installments = next;
            },
            immediate: true
        }
    },

    methods: {
        customLabel(option) {
            return `${option.name}`; // o cualquier combinación que quieras
        },

        async onCompaniesChange(selected) {
            const companyIds = selected.map(c => c.id);

            await this.catalogue.getUsersCompanies(companyIds);
            this.form.users = this.catalogue.users_companies.map(user => ({
                user_id: user.user_id,
                name: user.name + ' ' + user.last_name,
                company_id: user.company_id,
                company_name: user.company_name,
                amount: 0,
                selected: false,
                percentage: user.percentage,
            }));
        },

        closedModal() {
            this.form = {
                id: '',
                name: '',
                total: '',
                program_type_id: 1,
                contributions_count: '',
                company_ids: [],
                users: [],
                program_installments: [],
                buildings: []
            };
            this.$modal.hide('modalProgram');
        },

        async saveGroup() {
            let form = this.form;
            let endpoint = '/programs';

            try {
                let { data } = await request.post(endpoint, form);
                this.successNotification(data.message);
                this.closedModal();
                Event.$emit('event-load-program');
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error)
                }
            }
        },

        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success'
        }),
    },

    mounted() {
        this.catalogue.get_companies_all();
        this.catalogue.getProgramsTypes();
        this.catalogue.get_buildings();
        this.getUsers();
    },

    created() {
        Event.$on("event-from-program", () => {
            this.$modal.show('modalProgram')
        });
    }
}
</script>

<template>
    <modal name="modalProgram" :width="'60%'" :height="'auto'" :click-to-close="false">
        <form @submit.prevent="saveGroup">
            <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>

            <div class="modal-header">
                <h5 class="modal-title">Grupo del Programa</h5>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div :class="form.program_type_id == 1 ? 'col-md-3' : 'col-md-4'">
                        <div class="form-group">
                            <label>Nombre del Programa</label>
                            <input type="text" class="form-control" v-model="form.name">
                            <div v-if="errors.name" class="text-danger">{{ errors.name[0] }}</div>
                        </div>
                    </div>

                    <div :class="form.program_type_id == 1 ? 'col-md-3' : 'col-md-4'">
                        <div class="form-group">
                            <label>Tipo de Programa</label>
                            <select class="form-control" v-model="form.program_type_id">
                                <option v-for="type in catalogue.programs_types" :key="type.id" :value="type.id">
                                    {{ type.name }}
                                </option>
                            </select>
                            <div v-if="errors.program_type_id" class="text-danger">{{ errors.program_type_id[0] }}</div>
                        </div>
                    </div>

                    <div :class="form.program_type_id == 1 ? 'col-md-3' : 'col-md-4'">
                        <div class="form-group">
                            <label>Total</label>
                            <money class="form-control" v-model="form.total"></money>
                            <div v-if="errors.total" class="text-danger">{{ errors.total[0] }}</div>
                        </div>
                    </div>

                    <div class="col-md-3" v-if="form.program_type_id == 1">
                        <div class="form-group">
                            <label>Num. de aportaciones</label>
                            <input type="number" min="1" class="form-control" v-model="form.contributions_count">
                            <div v-if="errors.contributions_count" class="text-danger">
                                {{ errors.contributions_count[0] }}
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <hr>
                    </div>

                    <div class="col-md-12" v-if="form.program_type_id == 1">
                        <strong>Montos por aportación</strong>
                    </div>

                    <div class="col-md-12 mt-2" v-if="form.program_type_id == 1">
                        <div class="table-responsive">
                            <table class="table table-bordered text-center text-sm">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Monto</th>
                                        <th>Fecha (opcional)</th>
                                    </tr>
                                </thead>
                                <tbody v-if="form.program_installments.length > 0">
                                    <tr v-for="(it, idx) in form.program_installments" :key="idx">
                                        <td>{{ it.number }}</td>
                                        <td>
                                            <money class="form-control" v-model="form.program_installments[idx].amount">
                                            </money>
                                            <div v-if="errors[`program_installments.${idx}.amount`]"
                                                class="text-danger">
                                                {{ errors[`program_installments.${idx}.amount`][0] }}
                                            </div>
                                        </td>
                                        <td>
                                            <date-picker v-model="form.program_installments[idx].due_date"
                                                required="required" valueType="format"></date-picker>
                                            <div v-if="errors[`program_installments.${idx}.due_date`]"
                                                class="text-danger">
                                                {{ errors[`program_installments.${idx}.due_date`][0] }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="3">Sin montos.</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div v-if="errors.program_installments" class="text-danger">
                                {{ errors.program_installments[0] }}

                            </div>
                        </div>
                    </div>                

                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Propiedades</label>
                            <multiselect v-model="form.buildings" placeholder="Buscar un propiedad"
                                :custom-label="customLabel" track-by="id" :options="catalogue.buildings"
                                :multiple="true">
                            </multiselect>
                            <div v-if="errors.buildings" class="text-danger">{{ errors.buildings[0] }}</div>
                        </div>

                    </div>               

                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Empresas</label>
                            <multiselect v-model="form.company_ids" placeholder="Buscar una compañía"
                                :custom-label="customLabel" track-by="id" :options="catalogue.companies_all"
                                @input="onCompaniesChange" :multiple="true">
                            </multiselect>
                            <div v-if="errors.company_ids" class="text-danger">{{ errors.company_ids[0] }}</div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Usuarios</label>
                            <div class="row">
                                <div class="col-md-12 table-responsive">
                                    <table class="table table-bordered text-center text-sm">
                                        <thead>
                                            <tr>
                                                <th>Seleccionado</th>
                                                <th>Nombre</th>
                                                <th>Compañía</th>
                                                <!-- <th>Aportaciones</th> -->
                                                <th>Porcentaje</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="form.users.length > 0">
                                            <tr v-for="(user, index) in form.users" :key="index">
                                                <td>
                                                    <input type="checkbox" class="form-control form-control-sm"
                                                        v-model="form.users[index].selected">
                                                </td>
                                                <td>{{ user.name }}</td>
                                                <td>{{ user.company_name }}</td>
                                                <!-- <td>
                                                    <money class="form-control" v-model="user.amount"
                                                        :disabled="!user.selected"></money>
                                                </td> -->
                                                <td>
                                                    <money class="form-control" v-model="user.percentage" :prefix="''"
                                                        :disabled="!user.selected"></money>
                                                    <div v-if="errors[`users.${index}.percentage`]" class="text-danger">
                                                        {{ errors[`users.${index}.percentage`][0] }}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td align="center" colspan="5">Sin usuarios.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-if="errors.users" class="text-danger">{{ errors.users[0] }}</div>
                        </div>
                    </div>

                    <div class="col-md-12 mt-4">
                        <hr>
                        <button type="submit" class="btn float-right btn-outline-success">
                            <i class="fas fa-save"></i> Guardar
                        </button>
                        <button type="button" @click="closedModal" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i> Regresar
                        </button>
                    </div>

                </div>
            </div>
        </form>
    </modal>
</template>
